import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout";
import api from "../../lib/api";

export default function HSTeamProfile() {
    const { slug } = useParams();
    const [t, setT] = useState(null);
    const [err, setErr] = useState(null);
    useEffect(() => {
        api.get(`/football/hs/rankings/${slug}`).then(r => setT(r.data)).catch(() => setErr("Team not found"));
    }, [slug]);

    if (err) return <PageLayout><div className="pt-40 text-center text-white/40" data-testid="hs-team-error">{err}</div></PageLayout>;
    if (!t) return <PageLayout><div className="pt-40 text-center text-white/40">Loading…</div></PageLayout>;

    return (
        <PageLayout>
            <section className="relative min-h-[55vh] flex items-end pb-14 pt-24 overflow-hidden" data-testid="hs-team-hero">
                {t.hero_image && <img src={t.hero_image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-4">Rank #{t.rank}</div>
                    <h1 className="font-display text-5xl md:text-8xl text-white leading-[0.9] tracking-tight">
                        {t.school.toUpperCase()}
                    </h1>
                    <div className="text-white/70 uppercase tracking-widest mt-4 text-sm">{t.city}, {t.state} · {t.record || "—"} · Coach: {t.coach || "—"}</div>
                </div>
            </section>

            <section className="py-12">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-6">
                    <div className="lg:col-span-8 space-y-8">
                        <div>
                            <div className="section-label mb-4">Overview</div>
                            <p className="text-white/70 leading-relaxed">
                                {t.notes || "Digital Beast editors are publishing full team coverage for this program — schedule, roster spotlight, D1 prospects, and Road-to-the-League profiles. Check back weekly."}
                            </p>
                        </div>
                        {t.key_players?.length > 0 && (
                            <div>
                                <div className="section-label mb-4">Players to Watch</div>
                                <div className="flex flex-wrap gap-2">{t.key_players.map(p => <span key={p} className="chip">{p}</span>)}</div>
                            </div>
                        )}
                    </div>
                    <aside className="lg:col-span-4 space-y-4">
                        <div className="surface p-6">
                            <div className="section-label mb-3">Upcoming</div>
                            <div className="text-white text-lg">{t.upcoming_opponent || "TBD"}</div>
                            <div className="text-white/40 text-xs mt-1">{t.game_date || "Schedule updates weekly"}</div>
                        </div>
                        <Link to="/football/high-school" className="btn-outline w-full justify-center" data-testid="hs-team-back">Back to Top 50</Link>
                    </aside>
                </div>
            </section>
        </PageLayout>
    );
}
